import(/* webpackMode: "eager" */ "/app/src/app/auth/(login-register)/error.tsx");
